import { ModelDataType } from 'src/app/interfaces/model-data-type';

import { BaseModel } from './base-model';
import { Owner } from './owner';
import { User } from './user';
import { Vendor } from './vendor';

export class OwnerFinding extends BaseModel {
  static override columnMap = new Map<
    string,
    { property: string; type: 'column'; dataType: ModelDataType }
  >();
  static override associationMap = new Map<
    string,
    { property: string; type: 'association'; model: string }
  >();
  static override aliasedColumnMap = new Map<
    string,
    { property: string; type: 'alias' }
  >();

  static OwnerFindingProperties: (
    | {
        property: keyof OwnerFinding;
        type: 'column';
        dataType: ModelDataType;
      }
    | {
        property: keyof OwnerFinding;
        type: 'alias';
      }
    | {
        property: keyof OwnerFinding;
        type: 'association';
        model: string;
      }
  )[] = [
    { property: 'id', type: 'column', dataType: 'number' },
    { property: 'VendorId', type: 'column', dataType: 'number' },
    { property: 'OwnerId', type: 'column', dataType: 'number' },
    { property: 'ownerIdentity', type: 'column', dataType: 'number' },
    { property: 'ownerWatchlist', type: 'column', dataType: 'number' },
    { property: 'ownerFelony', type: 'column', dataType: 'number' },
    { property: 'ownerMisdemeanor', type: 'column', dataType: 'number' },
    { property: 'ownerBankruptcy', type: 'column', dataType: 'number' },
    { property: 'ownerLiens', type: 'column', dataType: 'number' },
    { property: 'ownerSexOffender', type: 'column', dataType: 'boolean' },
    { property: 'isOverrided', type: 'column', dataType: 'boolean' },
    { property: 'overrideDate', type: 'column', dataType: 'date' },
    { property: 'overridedBy', type: 'column', dataType: 'number' },
    { property: 'createdAt', type: 'column', dataType: 'date' },
    { property: 'updatedAt', type: 'column', dataType: 'date' },

    { property: 'Vendor', model: 'Vendor', type: 'association' },
    { property: 'Owner', model: 'Owner', type: 'association' },
    { property: 'User', model: 'User', type: 'association' }
  ];

  static {
    OwnerFinding.OwnerFindingProperties.forEach((propertyObject) => {
      const { property, type } = propertyObject;
      if (type === 'column') {
        OwnerFinding.columnMap.set(property, propertyObject);
      }
      if (type === 'alias') {
        OwnerFinding.aliasedColumnMap.set(
          property,
          propertyObject as { property: string; type: 'alias' }
        );
      }
      if (type === 'association') {
        OwnerFinding.associationMap.set(
          property,
          propertyObject as {
            property: string;
            type: 'association';
            model: string;
          }
        );
      }
    });
  }

  constructor(OwnerFindingObject: Partial<OwnerFinding>) {
    super();

    OwnerFinding.OwnerFindingProperties.forEach((propertyObject) => {
      const { property } = propertyObject;
      const value = OwnerFindingObject[property];
      if (value !== undefined) {
        Object.assign(this, { [property]: value });
      }
    });
  }

  id?: number;
  OwnerId?: number;
  VendorId?: number;
  ownerIdentity?: number | null;
  ownerWatchlist?: number | null;
  ownerFelony?: number | null;
  ownerMisdemeanor?: number | null;
  ownerBankruptcy?: number | null;
  ownerLiens?: number | null;
  ownerSexOffender?: boolean | null;
  isOverrided?: boolean;
  overrideDate?: Date | null;
  overridedBy?: number;
  createdAt?: Date;
  updatedAt?: Date;

  Vendor?: Vendor;
  Owner?: Owner;
  User?: User;
}
